// import React from "react";

// const WhyChooseUs = () => {
//     return (
//         <>
//             <style>{`
//                 .why-choose-us-section {
//                     overflow: hidden;
//                     padding: 20px 0;
//                     background: #e9f0e5;
//                 }

//                 .why-choose-us-container {
//                     width: 100%;
//                     max-width: 1620px;
//                     margin: 0 auto;
//                     padding: 0 15px;
//                 }

//                 .why-choose-us-grid {
//                     display: grid;
//                     grid-template-columns: 1fr;
//                     gap: 25px;
//                     align-items: center;
//                 }

//                 /* Content */

//                 .why-choose-us-content {
//                     max-width: 630px;
//                     margin-left: auto;
//                 }

//                 .why-choose-us-title {
//                     display: flex;
//                     align-items: center;
//                     gap: 8px;
//                     margin-bottom: 12px;
//                 }

//                 .why-choose-us-title-lines {
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 2px;
//                     flex-shrink: 0;
//                 }

//                 .why-choose-us-title-lines span:nth-child(1) {
//                     display: block;
//                     width: 20px;
//                     height: 1px;
//                     background: #000;
//                 }

//                 .why-choose-us-title-lines span:nth-child(2) {
//                     display: block;
//                     width: 1px;
//                     height: 20px;
//                     background: #000;
//                 }

//                 .why-choose-us-title-lines span:nth-child(3) {
//                     display: block;
//                     width: 1px;
//                     height: 30px;
//                     background: #000;
//                 }

//                 .why-choose-us-title h2 {
//                     margin: 0;
//                     font-size: 20px;
//                     line-height: 1.2;
//                     font-weight: 600;
//                 }

//                 .why-choose-us-intro {
//                     max-width: 540px;
//                     margin: 0;
//                     font-size: 16px;
//                     line-height: 1.6;
//                     font-weight: 500;
//                 }

//                 /* Features */

//                 .why-choose-us-list {
//                     max-width: 540px;
//                     margin: 25px 0;
//                     padding: 0;
//                     list-style: none;
//                 }

//                 .why-choose-us-item {
//                     position: relative;
//                     padding-left: 58px;
//                     margin-bottom: 20px;
//                 }

//                 .why-choose-us-item:last-child {
//                     margin-bottom: 0;
//                 }

//                 .why-choose-us-icon {
//                     position: absolute;
//                     top: 4px;
//                     left: 0;
//                     color: #000;
//                     font-size: 40px;
//                     line-height: 1;
//                 }

//                 .why-choose-us-item h3 {
//                     margin: 0 0 12px;
//                     font-size: 16px;
//                     line-height: 1.2;
//                     font-weight: 600;
//                 }

//                 .why-choose-us-item p {
//                     margin: 0;
//                     font-weight: 500;
//                     line-height: 1.6;
//                 }

//                 .why-choose-us-divider {
//                     height: 1px;
//                     margin-top: 20px;
//                     background: rgba(0, 0, 0, 0.2);
//                 }

//                 /* Statistics */

//                 .why-choose-us-stats {
//                     display: flex;
//                     flex-wrap: wrap;
//                     gap: 25px;
//                     max-width: 540px;
//                 }

//                 .why-choose-us-stat {
//                     display: block;
//                 }

//                 .why-choose-us-number {
//                     margin-bottom: 5px;
//                     color: #000;
//                     font-size: 50px;
//                     line-height: 1;
//                     font-weight: 700;
//                 }

//                 .why-choose-us-number span {
//                     color: #666;
//                     font-size: 36px;
//                     font-weight: 400;
//                 }

//                 .why-choose-us-stat > span {
//                     display: block;
//                 }

//                 /* Images */

//                 .why-choose-us-images {
//                     position: relative;
//                     text-align: center;
//                 }

//                 .why-choose-us-image {
//                     border-radius: 15px;
//                 }

//                 .why-choose-us-image img {
//                     display: block;
//                     width: 100%;
//                     height: auto;
//                     border-radius: 10px;
//                 }

//                 .image-one {
//                     max-width: 465px;
//                     margin-bottom: 20px;
//                     border: 5px solid #fff;
//                     transform: rotate(-5deg);
//                 }

//                 .image-two {
//                     max-width: 350px;
//                     margin-bottom: 20px;
//                     border: 5px solid #fff;
//                     transform: rotate(5deg);
//                 }

//                 .image-three {
//                     max-width: 220px;
//                     margin-bottom: 20px;
//                     transform: rotate(-5deg);
//                 }

//                 /* Tablet */

//                 @media (min-width: 768px) {

//                     .why-choose-us-section {
//                         padding: 20px 0;
//                     }

//                     .why-choose-us-title {
//                         margin-bottom: 15px;
//                     }

//                     .why-choose-us-title h2 {
//                         font-size: 24px;
//                     }

//                     .why-choose-us-intro {
//                         font-size: 18px;
//                     }

//                     .why-choose-us-list {
//                         margin-top: 30px;
//                         margin-bottom: 30px;
//                     }

//                     .why-choose-us-item {
//                         padding-left: 72px;
//                         margin-bottom: 25px;
//                     }

//                     .why-choose-us-icon {
//                         font-size: 50px;
//                     }

//                     .why-choose-us-item h3 {
//                         font-size: 18px;
//                         margin-bottom: 15px;
//                     }

//                     .why-choose-us-stats {
//                         gap: 50px;
//                     }

//                     .why-choose-us-number {
//                         font-size: 80px;
//                     }

//                     .why-choose-us-number span {
//                         font-size: 48px;
//                     }

//                     .why-choose-us-images {
//                         padding-top: 210px;
//                     }

//                     .why-choose-us-image {
//                         position: absolute;
//                         margin-bottom: 0;
//                         border-width: 10px;
//                     }

//                     .image-one {
//                         left: 0;
//                         max-width: 465px;
//                     }

//                     .image-two {
//                         top: 0;
//                         right: 0;
//                         max-width: 350px;
//                     }

//                     .image-three {
//                         top: 35px;
//                         left: 0;
//                         max-width: 220px;
//                         border: none;
//                     }
//                 }

//                 /* Desktop */

//                 @media (min-width: 1024px) {

//                     .why-choose-us-section {
//                         padding: 20px 0;
//                     }

//                     .why-choose-us-container {
//                         padding: 0 25px;
//                     }

//                     .why-choose-us-grid {
//                         grid-template-columns: 1fr 1fr;
//                     }

//                     .why-choose-us-title h2 {
//                         font-size: 30px;
//                     }

//                     .why-choose-us-list {
//                         margin-top: 35px;
//                         margin-bottom: 35px;
//                     }

//                     .why-choose-us-item {
//                         padding-left: 88px;
//                     }

//                     .why-choose-us-item h3 {
//                         font-size: 20px;
//                     }

//                     .why-choose-us-images {
//                         padding-left: 25px;
//                     }

//                     .image-one {
//                         max-width: 400px;
//                     }

//                     .image-two {
//                         right: 25px;
//                         max-width: 240px;
//                     }

//                     .image-three {
//                         top: 55px;
//                         max-width: 190px;
//                     }

//                     .why-choose-us-stats {
//                         gap: 75px;
//                     }

//                     .why-choose-us-number {
//                         font-size: 110px;
//                     }
//                 }

//                 /* Large Desktop */

//                 @media (min-width: 1280px) {

//                     .why-choose-us-section {
//                         padding: 20px 0;
//                     }

//                     .why-choose-us-container {
//                         padding: 0;
//                     }

//                     .why-choose-us-images {
//                         padding-left: 0;
//                     }

//                     .image-one {
//                         max-width: 465px;
//                     }

//                     .image-two {
//                         right: 25px;
//                         max-width: 350px;
//                     }

//                     .image-three {
//                         max-width: 220px;
//                     }

//                     .why-choose-us-stats {
//                         gap: 100px;
//                     }
//                 }

//                 /* Extra Large Desktop */

//                 @media (min-width: 1536px) {

//                     .why-choose-us-container {
//                         max-width: 1620px;
//                     }

//                     .why-choose-us-images {
//                         padding-left: 25px;
//                     }

//                     .image-two {
//                         right: 0;
//                         max-width: 430px;
//                     }

//                     .image-three {
//                         top: 10px;
//                         left: 40px;
//                         max-width: 280px;
//                     }
//                 }

//                 /* Dark Mode */

//                 @media (prefers-color-scheme: dark) {

//                     .why-choose-us-section {
//                         background: #171e20;
//                         color: #fff;
//                     }

//                     .why-choose-us-title-lines span {
//                         background: #fff;
//                     }

//                     .why-choose-us-icon {
//                         color: #fff;
//                     }

//                     .why-choose-us-number {
//                         color: #fff;
//                     }

//                     .why-choose-us-number span {
//                         color: rgba(255, 255, 255, 0.7);
//                     }

//                     .image-one,
//                     .image-two {
//                         border-color: #000;
//                     }

//                     .why-choose-us-divider {
//                         background: rgba(255, 255, 255, 0.2);
//                     }
//                 }
//             `}</style>

//             <section className="why-choose-us-section">
//                 <div className="why-choose-us-container">
//                     <div className="why-choose-us-grid">

//                         {/* Left Content */}
//                         <div>
//                             <div
//                                 className="why-choose-us-content"
//                                 data-cues="slideInUp"
//                                 data-group="whyChooseUsContent"
//                             >
//                                 <div className="why-choose-us-title">
//                                     <div className="why-choose-us-title-lines">
//                                         <span></span>
//                                         <span></span>
//                                         <span></span>
//                                     </div>

//                                     <h2>Why Choose RentQ?</h2>
//                                 </div>

//                                 <p className="why-choose-us-intro">
//                                     Discover the difference with our customer-first
//                                     approach, premium vehicles, and seamless rental
//                                     experience designed for modern travelers.
//                                 </p>

//                                 <ul className="why-choose-us-list">

//                                     <li className="why-choose-us-item">
//                                         <div className="why-choose-us-icon">
//                                             <i className="flaticon-price-tag-1"></i>
//                                         </div>

//                                         <h3>Transparent Pricing</h3>

//                                         <p>
//                                             No hidden fees or surprise charges. Our
//                                             all-inclusive pricing means the price you
//                                             see is the price you pay.
//                                         </p>

//                                         <div className="why-choose-us-divider"></div>
//                                     </li>

//                                     <li className="why-choose-us-item">
//                                         <div className="why-choose-us-icon">
//                                             <i className="flaticon-protection"></i>
//                                         </div>

//                                         <h3>Premium Insurance</h3>

//                                         <p>
//                                             Comprehensive coverage options with zero
//                                             deductibles and 24/7 roadside assistance
//                                             for complete peace of mind.
//                                         </p>

//                                         <div className="why-choose-us-divider"></div>
//                                     </li>

//                                     <li className="why-choose-us-item">
//                                         <div className="why-choose-us-icon">
//                                             <i className="flaticon-24-hours-support"></i>
//                                         </div>

//                                         <h3>Instant Booking</h3>

//                                         <p>
//                                             Book your perfect car in under 2 minutes
//                                             with our streamlined process and instant
//                                             confirmation.
//                                         </p>

//                                         <div className="why-choose-us-divider"></div>
//                                     </li>

//                                     <li className="why-choose-us-item">
//                                         <div className="why-choose-us-icon">
//                                             <i className="flaticon-support"></i>
//                                         </div>

//                                         <h3>24/7 Support</h3>

//                                         <p>
//                                             Our dedicated customer service team is
//                                             available around the clock to assist with
//                                             any questions or issues.
//                                         </p>

//                                         <div className="why-choose-us-divider"></div>
//                                     </li>

//                                 </ul>

                              
//                             </div>
//                         </div>

//                         {/* Right Images */}
//                         <div
//                             className="why-choose-us-images"
//                             data-cues="slideInUp"
//                             data-group="whyChooseUsImage"
//                         >
//                             <div className="why-choose-us-image image-one">
//                                 <img
//                                     src="/images/why-choose-us1.jpg"
//                                     alt="Why choose us"
//                                 />
//                             </div>

//                             <div className="why-choose-us-image image-two">
//                                 <img
//                                     src="/images/why-choose-us2.jpg"
//                                     alt="Why choose us"
//                                 />
//                             </div>

//                             <div className="why-choose-us-image image-three">
//                                 <img
//                                     src="/images/why-choose-us3.jpg"
//                                     alt="Why choose us"
//                                 />
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default WhyChooseUs;



import React from "react";

const WhyChooseUs = () => {
    // Reusable SVG icons
    const PriceTagIcon = () => (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M20.59 13.41 11 3.83V3H4v7h.83l9.58 9.59a2 2 0 0 0 2.83 0l3.35-3.35a2 2 0 0 0 0-2.83Z" />
            <circle cx="7.5" cy="6.5" r="1" />
        </svg>
    );

    const ShieldIcon = () => (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
            <path d="m9 12 2 2 4-4" />
        </svg>
    );

    const ClockIcon = () => (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </svg>
    );

    const SupportIcon = () => (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M4 14a8 8 0 0 1 16 0" />
            <path d="M4 14v4a2 2 0 0 0 2 2h1v-6H4Z" />
            <path d="M20 14v4a2 2 0 0 1-2 2h-1v-6h3Z" />
            <path d="M17 20h-2" />
        </svg>
    );

    return (
        <>
            <style>{`
                .why-choose-us-section {
                    overflow: hidden;
                    padding: 20px 0;
                    background: #fff7ed;
                }

                .why-choose-us-container {
                    width: 100%;
                    max-width: 1620px;
                    margin: 0 auto;
                    padding: 0 15px;
                }

                .why-choose-us-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 25px;
                    align-items: center;
                }

                /* =========================
                   CONTENT
                ========================= */

                .why-choose-us-content {
                    max-width: 630px;
                    margin-left: auto;
                }

                .why-choose-us-title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 12px;
                }

                .why-choose-us-title-lines {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 2px;
                    flex-shrink: 0;
                }

                .why-choose-us-title-lines span:nth-child(1) {
                    display: block;
                    width: 20px;
                    height: 1px;
                    background: #000;
                }

                .why-choose-us-title-lines span:nth-child(2) {
                    display: block;
                    width: 1px;
                    height: 20px;
                    background: #000;
                }

                .why-choose-us-title-lines span:nth-child(3) {
                    display: block;
                    width: 1px;
                    height: 30px;
                    background: #000;
                }

                .why-choose-us-title h2 {
                    margin: 0;
                    font-size: 20px;
                    line-height: 1.2;
                    font-weight: 600;
                }

                .why-choose-us-intro {
                    max-width: 540px;
                    margin: 0;
                    font-size: 16px;
                    line-height: 1.6;
                    font-weight: 500;
                }

                /* =========================
                   FEATURES
                ========================= */

                .why-choose-us-list {
                    max-width: 540px;
                    margin: 25px 0;
                    padding: 0;
                    list-style: none;
                }

                .why-choose-us-item {
                    position: relative;
                    padding-left: 58px;
                    margin-bottom: 20px;
                }

                .why-choose-us-item:last-child {
                    margin-bottom: 0;
                }

                .why-choose-us-icon {
                    position: absolute;
                    top: 2px;
                    left: 0;

                    width: 42px;
                    height: 42px;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    color: #000;
                }

                .why-choose-us-icon svg {
                    width: 40px;
                    height: 40px;
                    display: block;
                }

                .why-choose-us-item h3 {
                    margin: 0 0 12px;
                    font-size: 16px;
                    line-height: 1.2;
                    font-weight: 600;
                }

                .why-choose-us-item p {
                    margin: 0;
                    font-weight: 500;
                    line-height: 1.6;
                }

                .why-choose-us-divider {
                    height: 1px;
                    margin-top: 20px;
                    background: rgba(0, 0, 0, 0.2);
                }

                /* =========================
                   IMAGES
                ========================= */

                .why-choose-us-images {
                    position: relative;
                    text-align: center;
                    min-height: 400px;
                }

                .why-choose-us-image {
                    border-radius: 15px;
                    overflow: hidden;
                }

                .why-choose-us-image img {
                    display: block;
                    width: 100%;
                    height: auto;
                    border-radius: 10px;
                }

                .image-one {
                    max-width: 465px;
                    margin-bottom: 20px;
                    border: 5px solid #fff;
                    transform: rotate(-5deg);
                }

                .image-two {
                    max-width: 350px;
                    margin-bottom: 20px;
                    border: 5px solid #fff;
                    transform: rotate(5deg);
                }

                .image-three {
                    max-width: 220px;
                    margin-bottom: 20px;
                    transform: rotate(-5deg);
                }

                /* =========================
                   TABLET
                ========================= */

                @media (min-width: 768px) {

                    .why-choose-us-section {
                        padding: 20px 0;
                    }

                    .why-choose-us-title {
                        margin-bottom: 15px;
                    }

                    .why-choose-us-title h2 {
                        font-size: 24px;
                    }

                    .why-choose-us-intro {
                        font-size: 18px;
                    }

                    .why-choose-us-list {
                        margin-top: 30px;
                        margin-bottom: 30px;
                    }

                    .why-choose-us-item {
                        padding-left: 72px;
                        margin-bottom: 25px;
                    }

                    .why-choose-us-icon {
                        width: 55px;
                        height: 55px;
                    }

                    .why-choose-us-icon svg {
                        width: 50px;
                        height: 50px;
                    }

                    .why-choose-us-item h3 {
                        font-size: 18px;
                        margin-bottom: 15px;
                    }

                    .why-choose-us-images {
                        padding-top: 210px;
                    }

                    .why-choose-us-image {
                        position: absolute;
                        margin-bottom: 0;
                        border-width: 10px;
                    }

                    .image-one {
                        left: 0;
                        max-width: 465px;
                    }

                    .image-two {
                        top: 0;
                        right: 0;
                        max-width: 350px;
                    }

                    .image-three {
                        top: 35px;
                        left: 0;
                        max-width: 220px;
                        border: none;
                    }
                }

                /* =========================
                   DESKTOP
                ========================= */

                @media (min-width: 1024px) {

                    .why-choose-us-section {
                        padding: 20px 0;
                    }

                    .why-choose-us-container {
                        padding: 0 25px;
                    }

                    .why-choose-us-grid {
                        grid-template-columns: 1fr 1fr;
                    }

                    .why-choose-us-title h2 {
                        font-size: 30px;
                    }

                    .why-choose-us-list {
                        margin-top: 35px;
                        margin-bottom: 35px;
                    }

                    .why-choose-us-item {
                        padding-left: 88px;
                    }

                    .why-choose-us-item h3 {
                        font-size: 20px;
                    }

                    .why-choose-us-images {
                        padding-left: 25px;
                    }

                    .image-one {
                        max-width: 400px;
                    }

                    .image-two {
                        right: 25px;
                        max-width: 240px;
                    }

                    .image-three {
                        top: 55px;
                        max-width: 190px;
                    }
                }

                /* =========================
                   LARGE DESKTOP
                ========================= */

                @media (min-width: 1280px) {

                    .why-choose-us-section {
                        padding: 20px 0;
                    }

                    .why-choose-us-container {
                        padding: 0;
                    }

                    .why-choose-us-images {
                        padding-left: 0;
                    }

                    .image-one {
                        max-width: 465px;
                    }

                    .image-two {
                        right: 25px;
                        max-width: 350px;
                    }

                    .image-three {
                        max-width: 220px;
                    }
                }

                /* =========================
                   EXTRA LARGE DESKTOP
                ========================= */

                @media (min-width: 1536px) {

                    .why-choose-us-container {
                        max-width: 1620px;
                    }

                    .why-choose-us-images {
                        padding-left: 25px;
                    }

                    .image-two {
                        right: 0;
                        max-width: 430px;
                    }

                    .image-three {
                        top: 10px;
                        left: 40px;
                        max-width: 280px;
                    }
                }

                /* =========================
                   DARK MODE
                ========================= */

                @media (prefers-color-scheme: dark) {

                    .why-choose-us-section {
                        background: #171e20;
                        color: #fff;
                    }

                    .why-choose-us-title-lines span {
                        background: #fff;
                    }

                    .why-choose-us-icon {
                        color: #fff;
                    }

                    .image-one,
                    .image-two {
                        border-color: #000;
                    }

                    .why-choose-us-divider {
                        background: rgba(255, 255, 255, 0.2);
                    }
                }
            `}</style>

            <section className="why-choose-us-section">
                <div className="why-choose-us-container">

                    <div className="why-choose-us-grid">

                        {/* =========================
                            LEFT CONTENT
                        ========================= */}

                        <div>
                            <div
                                className="why-choose-us-content"
                                data-cues="slideInUp"
                                data-group="whyChooseUsContent"
                            >

                                <div className="why-choose-us-title">

                                    <div className="why-choose-us-title-lines">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>

                                    <h2>Why Choose RentQ?</h2>

                                </div>

                                <p className="why-choose-us-intro">
                                    Discover the difference with our customer-first
                                    approach, premium vehicles, and seamless rental
                                    experience designed for modern travelers.
                                </p>

                                <ul className="why-choose-us-list">

                                    {/* Transparent Pricing */}
                                    <li className="why-choose-us-item">

                                        <div className="why-choose-us-icon">
                                            <PriceTagIcon />
                                        </div>

                                        <h3>Transparent Pricing</h3>

                                        <p>
                                            No hidden fees or surprise charges. Our
                                            all-inclusive pricing means the price you
                                            see is the price you pay.
                                        </p>

                                        <div className="why-choose-us-divider"></div>

                                    </li>

                                    {/* Premium Insurance */}
                                    <li className="why-choose-us-item">

                                        <div className="why-choose-us-icon">
                                            <ShieldIcon />
                                        </div>

                                        <h3>Premium Insurance</h3>

                                        <p>
                                            Comprehensive coverage options with zero
                                            deductibles and 24/7 roadside assistance
                                            for complete peace of mind.
                                        </p>

                                        <div className="why-choose-us-divider"></div>

                                    </li>

                                    {/* Instant Booking */}
                                    <li className="why-choose-us-item">

                                        <div className="why-choose-us-icon">
                                            <ClockIcon />
                                        </div>

                                        <h3>Instant Booking</h3>

                                        <p>
                                            Book your perfect car in under 2 minutes
                                            with our streamlined process and instant
                                            confirmation.
                                        </p>

                                        <div className="why-choose-us-divider"></div>

                                    </li>

                                    {/* 24/7 Support */}
                                    <li className="why-choose-us-item">

                                        <div className="why-choose-us-icon">
                                            <SupportIcon />
                                        </div>

                                        <h3>24/7 Support</h3>

                                        <p>
                                            Our dedicated customer service team is
                                            available around the clock to assist with
                                            any questions or issues.
                                        </p>

                                        <div className="why-choose-us-divider"></div>

                                    </li>

                                </ul>

                            </div>
                        </div>

                        {/* =========================
                            RIGHT IMAGES
                        ========================= */}

                        <div
                            className="why-choose-us-images"
                            data-cues="slideInUp"
                            data-group="whyChooseUsImage"
                        >

                            <div className="why-choose-us-image image-one">
                                <img
                                    src="/images/why-choose-us4.png"
                                    alt="Why choose us"
                                />
                            </div>

                            <div className="why-choose-us-image image-two">
                                <img
                                    src="/images/why-choose-use.png"
                                    alt="Why choose us"
                                />
                            </div>

                            <div className="why-choose-us-image image-three">
                                <img
                                    src="/images/why-choose-us3.jpg"
                                    alt="Why choose us"
                                />
                            </div>

                        </div>

                    </div>

                </div>
            </section>
        </>
    );
};

export default WhyChooseUs;
